import Lottie from "lottie-react";

import { Box, Typography } from '@mui/material';

import loadingJson from 'assets/animation/loading-logo-ituran.json';
import { ReactComponent as IcIturan } from 'assets/icons/ic-ituran.svg';
import BannerValidateIturin from 'assets/images/banner-loading-iturin.png';

const Loading = () => {
    return (
        <Box position='relative' width='100%' bgcolor='primary.50' height='100vh' borderBottom='8px solid' borderColor='secondary.main'>
            <Box position='absolute' margin='0 auto' width='fit-content' height='fit-content' sx={{
                inset: '0',
                top: { xs: '2.25rem', md: '3.38rem' },
                'svg': {
                    height: '3.38rem'
                }
            }}>
                <IcIturan />
            </Box>
            <Box paddingTop='' width='100%' height='100%' display='grid' textAlign='center' alignItems='center' overflow='auto'>
                <Box display='grid' justifyItems='center'>
                    <Box sx={{ marginTop: '5px', svg: { maxHeight: '13rem' } }}>
                        <Lottie animationData={loadingJson} loop={true} />
                    </Box>
                    <Typography color='white' fontWeight={700} sx={{ fontSize: { xs: '1.5rem', md: '1.875rem' } }}>
                        Check-in do agendamento!
                    </Typography>
                    <Typography color='white' paddingTop='.2rem' lineHeight='1.2' sx={{
                        maxWidth: { xs: '20rem', md: '100%' },
                        fontSize: { xs: '1.125rem', md: '1.5rem' },
                        'b': {
                            color: 'secondary.main'
                        }
                    }}>
                        <b>Aguarde um momento</b>, estamos validando seus dados...
                    </Typography>
                    <Box display='grid' justifyContent='center' sx={{
                        paddingTop: '2.75rem',
                        'img': {
                            width: '100%',
                            height: 'auto',
                            maxWidth: { xs: '15rem', md: '23.25rem' }
                        }
                    }}>
                        <img src={BannerValidateIturin} alt='token ilustrativo' />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

export default Loading;